import { IconMapHighway16 } from '@cian/ui-kit-design-tokens/icons';
import { UIText2 } from '@cian/ui-kit/typography';
import * as React from 'react';

import * as styles from './styles.css';
import { IHighwayMobSiteSchema } from '../../types/recommendation';

export interface IHighwaysProps {
  highway: IHighwayMobSiteSchema;
}

export function Highway({ highway }: IHighwaysProps): React.JSX.Element {
  const { id, name, distance } = highway;

  return (
    <div key={id} className={styles['container']}>
      <div className={styles['icon']}>
        <IconMapHighway16 display="block" color="icon-primary-default" />
      </div>
      <span className={styles['name']}>
        <UIText2 display="inline">{name}</UIText2>
      </span>
      {distance && <UIText2 display="inline">{`, ${distance}`}</UIText2>}
    </div>
  );
}
